import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { CleaningDetailPage } from "@/features/tasks/pages/cleaning-detail-page/cleaning-detail-page";

export const Route = createFileRoute(
	"/_authenticated/admin/tasks/cleaning/$cleaningId"
)({
	head: () => pageTitle("Cleaning"),
	component: CleaningDetailPage,
});
